import { Subscription } from "@/types/subscription"

import api from "@/services/api"

class SubscriptionService {
	private get axios () { return api.getAxios() }

	public async getSubscriptionAsync (): Promise<Subscription> {
		return (await this.axios.get("/subscription")).data
	}
}

const subscriptionService = new SubscriptionService()
export default subscriptionService
